import { useEffect, useState, useRef } from 'react';
import isEmpty from 'lodash/isEmpty';
import differenceWith from 'lodash/differenceWith';
import isEqual from 'lodash/isEqual';

export const useSortActiveFiltersByAdding = (filters) => {
  const filterStateRef = useRef([]);
  const [sortedActiveFilters, setSortedActiveFilters] = useState([]);

  useEffect(() => {
    const filteredIds = getArrayWithFilteredIds(filters);

    const addedFilteredIds = differenceWith(filteredIds, filterStateRef.current, isEqual);
    const deletedFilteredIds = differenceWith(filterStateRef.current, filteredIds, isEqual);

    if (isEmpty(addedFilteredIds) && isEmpty(deletedFilteredIds)) {
      return;
    }

    filterStateRef.current = [
      ...filterOutRemovedIds(filterStateRef.current, deletedFilteredIds),
      ...addedFilteredIds,
    ];

    setSortedActiveFilters(filterStateRef.current);
  }, [filters]);

  return {
    sortedActiveFilters,
  };
};

function getArrayWithFilteredIds(filters) {
  if (!filters) {
    return [];
  }

  return Object.entries(filters).reduce((result, [key, value]) => {
    const filterResult = value.map((id) => ({ key, id }));

    return [...result, ...filterResult];
  }, []);
}

function filterOutRemovedIds(filterState, deletedFilteredIds) {
  return filterState.filter((filteredId) => !deletedFilteredIds.some(deletedId => isEqual(deletedId, filteredId)));
}
